import Image from 'next/image'
import { getProgramData } from '~shared/api/single-program-data/single-program-data'
import defaultAvatar from './images/default-avatar.jpg'

// ─── Constants ────────────────────────────────────────────────────────────────

const TITLE = 'Что говорят выпускники?'

// ─── Component ────────────────────────────────────────────────────────────────

export const ReviewsSection = ({ program }: {
  program: Awaited<ReturnType<typeof getProgramData>>
}) => {
  const reviews = program?.reviewBlock
  const color = program?.faculty?.color ?? '#3A52EE'

  if (!reviews || reviews.length === 0) return null

  return (
    <section className='py-[56px] 2lg:py-[80px]'>
      <div className='mx-auto px-[16px] box-border max-w-[672px] md:max-w-[864px] 2lg:max-w-[1280px]'>

        <h2 className='text-[32px] md:text-[40px] 2lg:text-[48px] font-medium leading-[120%] text-center mb-[40px] 2lg:mb-[48px]'>
          {TITLE}
        </h2>

        {/* Top line */}
        <div className='w-full h-[1px] mb-[16px] md:mb-[24px]' style={{ backgroundColor: color }} />

        {reviews.map((review, idx) => (
          <div key={`Reviews__review--${idx + 1}`}>

            {/* Author row */}
            <div className='grid mb-[16px] 2lg:mb-[32px]' style={{ gridTemplate: 'auto / 0fr 1fr', columnGap: '16px', rowGap: '8px', alignItems: 'center' }}>
              <div className='relative row-span-2 w-[40px] h-[40px] 2lg:w-[48px] 2lg:h-[48px] rounded-full overflow-hidden shrink-0'>
                <Image
                  src={review?.userPhoto?.url || defaultAvatar}
                  alt={review?.userPhoto?.alternativeText || ''}
                  fill
                  className='object-cover'
                />
              </div>
              {review?.userName && (
                <p className='text-[16px] 2lg:text-[18px] font-medium leading-[120%]'>
                  {review.userName}
                </p>
              )}
            </div>

            {/* Review body */}
            {review?.reviewText && (
              <p className='text-[14px] md:text-[16px] 2lg:text-[18px] leading-[150%] mb-[16px] md:mb-[24px]'>
                {review.reviewText}
              </p>
            )}

            {/* Divider */}
            <div
              className={`w-full h-[1px] ${idx !== reviews.length - 1 ? 'mb-[16px] md:mb-[24px]' : ''}`}
              style={{ backgroundColor: color }}
            />

          </div>
        ))}

      </div>
    </section>
  )
}